
const languageMapping = (lang:any) => {
    
    var la = lang.indexOf('zh') > -1 ? 'zh-CN' : 'en-US' // 浏览器语言
    la = lang.indexOf('pt') > -1 ? 'pt' : la
    la = lang.indexOf('fr') > -1 ? 'fr' : la
    la = lang.indexOf('ja') > -1 ? 'ja' : la
    la = lang.toLowerCase().indexOf('zh-tw') > -1 ? 'zh-TW' : la
    la = lang.toLowerCase().indexOf('zh-hk') > -1 ? 'zh-TW' : la

   return la
}

export default languageMapping